export default class ExternalReviewGeneric {

    constructor(data, iconScore) {
        const t = document.querySelector('#external-review-generic');
        this.instance = t.content.cloneNode(true);
        this.data = data;
        if (data.isTotalReviews) {
            this.iconScore = iconScore;
            this.setTotalReviews();
        } else {
            this.setReview();
        }
        return this.instance;
    }

    setReview() {
        const review = this.instance.querySelector('[name="review"]');
        this.instance.querySelector('[name="total-reviews"]').remove();

        if (this.data.review_url) {
            review.href = this.data.review_url;
        }
        review.querySelector('[name="date"]').textContent = this.data.survey_date_interval_text;
        review.querySelector('[name="opinion"]').textContent = this.data.positive_review;
        review.querySelector('[name="fullName"]').textContent = this.data.user_alias;
        if (this.data.translated) {
            review.querySelector('[name="translated-text"]').textContent = this.data.translated_text;
            review.querySelector('[name="translated-icon"]').src = this.data.translated_icon;
        } else {
            review.querySelector('.footer').style.display = 'none';
        }
        let reviewInitial = review.querySelector('[name="review-initial"]');
        if (this.data.initial_img) {
            let initialIcon = document.createElement('i');
            initialIcon.classList.add('ci', 'ci-' + this.data.initial_img, 'ci-s-30', 'mr-1', 'color-danger');
            reviewInitial.className = "";
            reviewInitial.appendChild(initialIcon);
        } else {
            reviewInitial.textContent = this.data.user_alias.charAt(0);
            reviewInitial.classList.add('bg-' + this.data.user_color);
        }
    }

    setTotalReviews() {
        const totalReviews = this.instance.querySelector('[name="total-reviews"]');
        this.instance.querySelector('[name="review"]').remove();

        this.setScore(totalReviews);
        totalReviews.querySelector('[name="logo"]').src = this.data.logo;
        totalReviews.querySelector('[name="textScore"]').innerHTML = this.data.textScore;
        if (this.data.logoLink) totalReviews.querySelector('[name="logo-link"]').href = this.data.logoLink;

    }

    setScore(parent) {
        const scoreItemTemplate = parent.querySelector('[name="score"] [name="item-score"]');
        const scoreItems = [];
        for (let i = 0; i < this.data.score; i++) {

            const scoreItem = scoreItemTemplate.cloneNode(true);
            let iconContainer = scoreItem.querySelector('i');
            if (i !== 0) {
                iconContainer.classList.add('ml-1');
            }
            iconContainer.classList.add(this.iconScore);
            scoreItems.push(scoreItem);
        }
        const scoreItemsParent = scoreItemTemplate.parentNode;
        scoreItemTemplate.remove();
        scoreItems.forEach(scoreItem => scoreItemsParent.appendChild(scoreItem))
    }
}

